import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux-stores/store";
import { selectBarterCampaigns } from "../../redux-stores/selectors/campaignSelectors";
import "./style.scss";
import SponsorshipCampaignCard from "./SponsorshipCampaignCard";
import SponsorshipSectionSkeleton from "../../skeletons/SponsorshipSectionSkeleton";

const BarterCampaignsSection: React.FC = () => {
    const barterCampaigns = useSelector(selectBarterCampaigns);
    const loading = useSelector((state: RootState) => state.campaigns.loading);

    if (loading && barterCampaigns.length === 0) {
        return <div className="px-3"><SponsorshipSectionSkeleton /></div>;;
    }

    if (barterCampaigns.length === 0) {
        return null;
    }

    return (
        <section className="sponsorship-section gap-0">
            <p className="sponsorship-section-title px-3">BARTER SPONSORSHIPS</p>
            <div className="sponsorship-cards-scroll px-3 py-2">
                {barterCampaigns.map((campaign) => (
                    <SponsorshipCampaignCard
                        key={campaign.uuid}
                        campaign={campaign}
                    />
                ))}
            </div>
        </section>
    );
};

export default BarterCampaignsSection;
